import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Escapes real HTML special characters before any markdown-lite transform
// runs. Three separate call sites (App.js's account insight, IntelTab.js's
// briefing, OptionAnalysisModal.js's AI analysis) used to apply **bold**/
// *italic* regex replacement directly to raw AI/market-data-derived text
// with no escaping first — any literal HTML or a <script> payload already
// present in that text (a news headline, a ticker description, or the LLM
// response itself) would pass straight into dangerouslySetInnerHTML. Escape
// FIRST, then apply the markdown transforms on the now-safe text, so the
// only tags ever produced are the <strong>/<em> ones this function itself
// creates.
export function formatAiText(text) {
  if (!text) return "";
  const escaped = String(text)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
  return escaped
    .replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>")
    .replace(/\*(.*?)\*/g, "<em>$1</em>")
    .replace(/`(.*?)`/g, '<code style="background:rgba(255,255,255,0.08);padding:1px 4px;border-radius:3px">$1</code>');
}
